import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Log sécurisé de l'environnement
console.log('🔧 Environment:', process.env.NODE_ENV);
console.log('🔧 Version: TacticaFoot Public');

/**
 * Configuration Firebase pour TacticaFoot Public
 * 
 * Utilise l'authentification partagée avec l'application principale (tactica-70f74)
 * mais conserve son propre projet Firestore pour les données spécifiques à la version publique
 */
const firebaseConfig = {
  // Paramètres d'authentification partagés avec l'application principale
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  
  // Paramètres propres à TacticaFoot Public
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Vérifier que les variables d'environnement sont définies
if (!firebaseConfig.apiKey || !firebaseConfig.authDomain) {
  console.error('❌ Variables d\'environnement Firebase manquantes. Vérifiez votre fichier .env');
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Configurer la persistance locale pour maintenir la session utilisateur
// même après la fermeture du navigateur
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('✅ Persistance locale configurée avec succès');
  })
  .catch((error) => {
    console.error('❌ Erreur lors de la configuration de la persistance:', error);
    // En cas d'échec, l'authentification utilisera la persistance par défaut (session)
    console.warn('⚠️ Utilisation de la persistance par défaut (session)');
  });

// Utiliser la langue du navigateur pour l'authentification
auth.useDeviceLanguage();

// Initialiser Firestore
const db = getFirestore(app);

// Initialiser Analytics de manière sécurisée
let analytics: ReturnType<typeof getAnalytics> | null = null;

// Vérifier si Analytics est supporté avant de l'initialiser
if (process.env.NODE_ENV === 'production') {
  isSupported()
    .then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
        console.log('✅ Firebase Analytics initialisé avec succès');
      } else {
        console.log('⚠️ Firebase Analytics non supporté dans ce navigateur (normal pour Brave/Firefox avec blocage strict)');
      }
    })
    .catch((error) => {
      console.warn('⚠️ Impossible de vérifier le support d\'Analytics:', error);
    });
} else {
  console.log('🔧 Analytics désactivé en développement');
}

// Configuration des émulateurs pour le développement local
if (process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost') {
  console.log('🧪 Utilisation des émulateurs Firebase');
  // Décommenter les lignes suivantes pour utiliser les émulateurs
  // connectAuthEmulator(auth, 'http://localhost:9099');
  // connectFirestoreEmulator(db, 'localhost', 8080);
}

// URL de base de l'application principale
export const MAIN_APP_URL = 'https://app.tacticafoot.com';

export { app, auth, db, analytics };
